module.exports = __webpack_public_path__ + "static/textarea-label-do-d62223d2333dbf39af8fe2dab57da137.png";